/* Login screen: e-mail + password. "First time here / new code": e-mail + the owner's single-use invite code + a new
   password (the server function checks the code and creates or updates the login; nothing is e-mailed). */
import {sb, callFunction} from '../db.ts';
import {escapeHtml, $} from './common.ts';

export const MIN_PASSWORD = 10;
let mode: 'login' | 'claim' = 'login';
let msg = '';

export function renderLogin(root: HTMLElement): void {
  root.innerHTML = `
  <div class="card" style="max-width:420px; margin:40px auto 0;">
    <h2>${mode === 'login' ? 'Log in' : 'First time here / new code'}</h2>
    ${mode === 'claim' ? '<p class="muted-text">Use the code the owner gave you. It works once. You will choose your password now.</p>' : ''}
    <form id="authForm" autocomplete="on">
      <label class="field" for="aEmail">E-mail</label><input id="aEmail" type="email" autocomplete="username" required>
      ${mode === 'claim' ? `<label class="field" for="aCode">Invite code</label><input id="aCode" autocomplete="one-time-code" placeholder="XXXX-XXXX-XXXX" required style="text-transform:uppercase; letter-spacing:.05em;">` : ''}
      <label class="field" for="aPass">${mode === 'login' ? 'Password' : 'New password (at least ' + MIN_PASSWORD + ' characters)'}</label>
      <input id="aPass" type="password" autocomplete="${mode === 'login' ? 'current-password' : 'new-password'}" required>
      ${mode === 'claim' ? `<label class="field" for="aPass2">New password again</label><input id="aPass2" type="password" autocomplete="new-password" required>` : ''}
      <div id="aMsg" class="muted-text" style="margin-top:10px; color:var(--danger); min-height:1em;">${escapeHtml(msg)}</div>
      <div class="row between" style="margin-top:12px;">
        <a class="linklike" id="aSwitch">${mode === 'login' ? 'First time here / have a new code?' : '← Back to log in'}</a>
        <button class="btn primary" id="aGo" type="submit">${mode === 'login' ? 'Log in' : 'Set password and log in'}</button>
      </div>
    </form>
    <p class="muted-text" style="margin-top:14px;">Forgot your password? Ask the owner for a new code.</p>
  </div>`;
  $('aSwitch').onclick = () => { mode = mode === 'login' ? 'claim' : 'login'; msg = ''; renderLogin(root); };
  $<HTMLFormElement>('authForm').onsubmit = async (ev) => {
    ev.preventDefault();
    const email = $('aEmail').value.trim().toLowerCase(), pass = $('aPass').value, out = $('aMsg'), go = $<HTMLButtonElement>('aGo');
    out.textContent = ''; go.disabled = true;
    try {
      if (mode === 'claim') {
        if (pass.length < MIN_PASSWORD) throw new Error('Choose a password of at least ' + MIN_PASSWORD + ' characters.');
        if (pass !== $('aPass2').value) throw new Error('The two passwords are not the same.');
        await callFunction('claim', {email, code: $('aCode').value.trim(), password: pass}, false);
      }
      const {error} = await sb.auth.signInWithPassword({email, password: pass});
      if (error) throw new Error(error.message === 'Invalid login credentials' ? 'E-mail or password is not right.' : error.message);
      mode = 'login'; msg = '';   // onAuthStateChange takes over from here
    } catch (e: any) { out.textContent = e?.message || String(e); go.disabled = false; }
  };
}
